/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import track from 'react-tracking';
import { Link } from 'react-router-dom';
import TextTruncate from 'react-text-truncate';
import arrowWhite from 'assets/icons/nextWhite.svg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import baseUrl from 'shared/util/baseUrl';
// import numeral from 'numeral';
import './Recommendation.scss';
import ultilitiesService from 'shared/util/ultilitiesService';

// import trackSelectedProduct from './Product.tracking';

const Recommendation = ({
  intl, masterData, number, banner, etf, productType,
  // tracking,
}) => {
  // console.log('masterData', masterData);
  //  const stats = Object.keys(masterData.keyFacts).map(key => ({ title: key, value: masterData.keyFacts[key] }));
  const stats = masterData;
  return (
    <div className="nw-recommendation">
      <span className="nw-recommendation__number">{number}</span>
      <div
        className="nw-recommendation__banner"
        // style={{ background: `url(${baseUrl}/images/${banner[Math.floor(Math.random() * 6)]}) center / cover no-repeat` }}
        style={{ background: `url(${baseUrl}/images/compressed/${(banner && banner.replace('.png', '.jpg')) || 'banner-descretionary.jpg'}) center / cover no-repeat` }}
      />
      <div className="nw-recommendation__row">
        <h3>{masterData.fundName || ''}</h3>
        {/* <p> */}
        <TextTruncate
          line={3}
          element="span"
          truncateText="…"
          text={masterData.fundDescription || ''}
        />
        {/* </p> */}
      </div>
      {
            stats
            && (
            <div className="nw-recommendation__row nw-recommendation__stats">
              <div className="nw-recommendation__stat" key="mainFocus">
                <h5>{masterData.mainFocus || ''}</h5>
                <span>{intl.formatMessage({ id: 'products.mainFocus' })}</span>
              </div>
              <div className="nw-recommendation__stat" key="lastPrice">
                <h5>
                  {/* {`${etf ? (masterData.netAssets ? numeral(masterData.netAssets).format('0.000') : '') : (masterData.lastClosingPrice || masterData.navUnit || '')} ${masterData.currency}`} */}
                  {/* {etf && `${masterData.netAssetsCurrency} `} */}
                  {`${etf ? (masterData.netAssets ? ultilitiesService.formatUnitCurrency(masterData.netAssets, masterData.netAssetsCurrency) : '-') : (ultilitiesService.formatNavUnit(masterData.lastClosingPrice) || ultilitiesService.formatNavUnit(masterData.navUnit) || '-')} `}
                  {!etf && ` ${masterData.currency}`}
                </h5>
                <span>{etf ? intl.formatMessage({ id: 'products.AUM' }) : intl.formatMessage({ id: 'products.navUnit' })}</span>
              </div>
              <div className="nw-recommendation__stat" key="minInitialInvestment">
                <h5>
                  {/* {(masterData.keyFacts && masterData.keyFacts.minInitialInvestment) || ''} //ultilitiesService.formatDecimalToPercentage */}
                  {etf ? `${(Number(masterData.expensesRatio)).toFixed(2)} %` : (masterData.minInitialInvestment || '-')}
                </h5>
                <span>{etf ? intl.formatMessage({ id: 'products.expensesRatio' }) : intl.formatMessage({ id: 'products.minInvestment' })}</span>
              </div>
              <div className="nw-recommendation__stat" key="threeYearPerformance">
                <h5>{productType === 'markaz_real_estate' ? ultilitiesService.format3yPerformance(masterData.yearPerformanceValue) : (masterData.threeYearPerformance === null || masterData.threeYearPerformance === '') ? '-' : ultilitiesService.format3yPerformance(masterData.threeYearPerformance)}</h5>
                <span>
                  {productType === 'markaz_real_estate' && `${masterData.yearPerformance} Y `}
                  {' '}
                  {productType !== 'markaz_real_estate' ? intl.formatMessage({ id: 'products.3yPerformance' }) : intl.formatMessage({ id: 'products.performance' })}
                  {' '}
                  <em>{productType !== 'markaz_real_estate' && intl.formatMessage({ id: 'products.annualised' }) }</em>
                </span>
              </div>
            </div>
            )
        }
      <div
        className="nw-recommendation__knowMore"
        onClick={() => {
          // trackSelectedProduct(tracking, masterData.fundName);
        }}
      >
        {masterData.fundId && (
          <Link to={{
            pathname: `/fund-factsheet/${masterData.isin}`,
            state: { slide: number - 1 },
          }}
          >
            <FormattedMessage id="products.knowMore" />
              &nbsp; &nbsp;
            <img src={arrowWhite} alt="arrow" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default track({
  page: 'Recommendation',
})(Recommendation);
